// Homepage section order and hidden sections (today's order, nothing hidden).
import { HOME_SECTIONS } from "../homeLayout";

const layout = { order: HOME_SECTIONS.map((s) => s.id), hidden: [] };

export default { en: layout, fr: layout };
